/* The exercise table's own WAIT — the shape of the rows it is about to be.
 *
 * The centred box the four sentences stand in, and the two buttons under them, are
 * `shared/ui/listState.module.css`. What is here is this list's skeleton: the table's own head and
 * its own tracks (`ExerciseTable.module.css`'s `.gridRow`, worn by every skeleton row), so the wait
 * cannot disagree with the answer about where a column starts. Each row is `--h-ex-table-row` with
 * the same hairline, and a skeleton taller than its reserve would make the card shrink when the
 * answer lands, which is the defect it was added to prevent. */

/* The table's scroller, minus the scroll: the same 10px gutter is reserved, so the flexible tracks
 * stand where the loaded table's do rather than 10px wider. */
.skeletonList {
  --sb-size: 10px;
  --sb-radius: var(--radius-xs);

  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  scrollbar-gutter: stable;
}

.skeletonRow {
  height: var(--h-ex-table-row);
  border-bottom: var(--border-hairline) solid var(--border);
}

.skelNameCell {
  display: flex;
  gap: var(--space-3);
  align-items: center;
  min-width: 0;
}

/* Each bar is the box its answer will stand in, so the frame the catalogue lands on changes ink and
 * nothing else. The still keeps its exact shape; the text bars are shorter than their tracks, which
 * is what a skeleton reads as rather than a solid block. */
.skelStill {
  flex: none;
  width: 44px;
  height: 33px;
}

.skelName {
  width: 62%;
  height: 11px;
}

.skelType {
  width: 84px;
  height: 11px;
}

.skelPills {
  width: 78%;
  height: 22px;
}

.skelThumbs {
  width: 64px;
  height: 30px;
}
